<template>
  <tx-msg-box ref="gradeMsg" @close="close" class="grade-msg-box" :options="{ type: 'confirm', title: '试题评价', width: '540px', showClose: true, align: 'tl', confirmButtonText: '提交', confirmButtonClass: 'btn-primary', showCancelButton: true, callback: bindGradeQues, callbackClose: true}">
    <div class="comp-grade-pop pr20 pt30" id="gradePop">
      <el-form ref="form" label-width="100px">
        <el-form-item label="评价内容：">
          <el-input type="textarea" :rows="8" placeholder="我来说两句~~" v-model="gradeContent"></el-input>
        </el-form-item>
        <el-form-item label="打分：">
          <el-rate
            style="margin-top: 9px;"
            v-model="score"
            :max="10"
            :score-template="score + '分'"
            show-score
            allow-half>
          </el-rate>
        </el-form-item>
      </el-form>
    </div>
  </tx-msg-box>
</template>

<script>
  /*!*
   * @author yueheqin
   * @date 2019/7/9
   * @project zujuanzaixian
   * @desc
   */
  import {mapState, mapMutations, mapActions} from 'vuex'
  export default {
    name: 'comp-grade-pop',
    props: {},
    data () {
      return {
        gradeContent: '',
        score: 0
      }
    },
    computed: {
      ...mapState('pop', ['gradePopVisible', 'currentOprQues'])
    },
    watch: {
      'gradePopVisible': {
        handler (n, o) {
          if (n) {
            this.$nextTick(() => {
              this.open()
            })
          }
        },
        immediate: true
      }
    },
    methods: {
      ...mapMutations('pop', ['updateGradePopVisible']),
      ...mapActions('zujuan', ['commentTest']),
      bindGradeQues (type) {
        if (type === 'confirm') {
          if (!this.gradeContent) {
            this.$message.error('请输入评价内容')
            return
          }
          if (this.score <= 0) {
            this.$message.error('评分不能为0，请打分')
            return
          }
          this.commentTest({
            data: {
              testID: this.currentOprQues.testID,
              content: this.gradeContent,
              score: this.score
            },
            config: {
              loading: '#gradePop'
            }
          }).then(res => {
            this.$notify.success({
              title: '提示',
              message: '评价提交成功'
            })
            this.close()
            this.$refs.gradeMsg.close()
          })
        }
      },
      open () {
        this.score = 0
        this.gradeContent = ''
        this.$refs.gradeMsg.open()
      },
      close () {
        console.log('closeDialog')
        this.updateGradePopVisible(false)
      }
    }
  }
</script>

<style lang="less">
  .comp-grade-pop {
    .el-form-item {
      margin-bottom: 10px;
    }
  }
</style>
